import { useQuery } from '@tanstack/react-query';
import { crashesApi } from './api';

export function useCrashReport(id: string) {
  return useQuery({ queryKey: ['crash-report', id], queryFn: () => crashesApi.find(id), enabled: !!id, retry: false });
}
